
import EventPublisher from "../utils/EventPublisher";
import SecureRequestExecuter from "./requestExecuters/SecureRequestExecuter";
import SecureResponseHandler from "./ResponseHandlers/SecureResponseHandler";
import ActionResultEvents from "../constants/events/ActionResultEvents";


export default class EmailVerificationAPIClient {
    constructor() {
        this.requestEmailResponseHandler =
            new SecureResponseHandler(
                new Map()
                    .set("EMAIL_SENT", this.onEmailSent));

        this.checkCodeResponseHandler =
            new SecureResponseHandler(
                new Map()
                    .set("INVALID_EMAIL_VALIDATION_CODE", this.onInvalidEmailCode)
                    .set("EMAIL_VALIDATION_SUCCESS", this.onEmailValidated));
    }

    checkCode(validationCode) {
        SecureRequestExecuter.executePUTRequest(
            "/api/private/email_validation",
            {},
            {
                "email_verification_code": validationCode
            },
            {},
            this.checkCodeResponseHandler);
    }

    requestEmail() {
        SecureRequestExecuter.executePOSTRequest(
            "/api/private/email_validation",
            {},
            {},
            {},
            this.requestEmailResponseHandler);
    }

    onEmailSent = (responseHeaders, responseBodyContents, dataFromAction) => {
        EventPublisher.publish(
            ActionResultEvents.EMAIL_VERIFICATION_EMAIL_SENT,{});
    };

    onEmailValidated = (responseHeaders, responseBodyContents, dataFromAction) => {
        EventPublisher.publish(ActionResultEvents.EMAIL_VERIFICATION_SUCCESS, {});
    };

    onInvalidEmailCode = (responseHeaders, responseBodyContents, dataFromAction) => {
        EventPublisher.publish(ActionResultEvents.EMAIL_VERIFICATION_INVALID_CODE, {});
    };

}